export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.227 4.97a.672.672 0 01-.041.956L6.696 7.28h7.748c3.207 0 5.806 2.568 5.806 5.736 0 3.167-2.6 5.735-5.806 5.735H8.42a.682.682 0 01-.686-.677c0-.375.307-.678.686-.678h6.025c2.45 0 4.435-1.961 4.435-4.38 0-2.42-1.986-4.381-4.435-4.381H6.696l1.49 1.353a.672.672 0 01.041.957.692.692 0 01-.969.04L4.472 8.455a.674.674 0 010-.997l2.786-2.53a.692.692 0 01.97.041z\" fill=\"#6F7488\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};